// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeenAd":"co_a bib_fm bib_vv bib_xg bib_h"};